import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconShareSmall = ({ color, width = 12, height = 15 }) => {
  const colorCode = colorLookup(color) ?? colorLookup('blue');
  return (
    <SVG width={width} height={height} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7.2489V12.2491C1 12.5806 1.1317 12.8986 1.36612 13.133C1.60054 13.3674 1.91848 13.4991 2.25 13.4991H9.75C10.0815 13.4991 10.3995 13.3674 10.6339 13.133C10.8683 12.8986 11 12.5806 11 12.2491V7.2489"
        stroke={colorCode}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.49897 3.5L5.99903 1L3.49908 3.5" stroke={colorCode} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.99927 1V9.12477" stroke={colorCode} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SVG>
  );
};
export { IconShareSmall as default, IconShareSmall };
